import { EditSource } from '../../../../ui/features/sources/components/EditSource';
import { NewSource } from '../../../../ui/features/sources/components/NewSource';
import { SourceList } from '../../../../ui/features/sources/components/SourceList';
import React from 'react';
import { Route, Routes } from 'react-router';
export const SourcePanel = ({ hideHeader }) => {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: '', element: React.createElement(SourceList, { hideHeader: hideHeader }) }),
        React.createElement(Route, { path: '/new/*', element: React.createElement(NewSource, null) }),
        React.createElement(Route, { path: '/:sourceId/*', element: React.createElement(EditSource, null) })));
};
